(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-molecule-gift-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
      function bindVariantPriceButtons(root) {
        if (!root || root.dataset.bound === 'true') {
          return;
        }

        const select = root.querySelector('[data-gift-card-variant-select]');
        const buttons = root.querySelectorAll('[data-variant-price-button]');

        if (!(select instanceof HTMLSelectElement) || buttons.length === 0) {
          return;
        }

        root.dataset.bound = 'true';

        const syncButtons = () => {
          buttons.forEach((button) => {
            if (!(button instanceof HTMLButtonElement)) {
              return;
            }

            const isActive = button.dataset.variantId === select.value;
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        };

        buttons.forEach((button) => {
          if (!(button instanceof HTMLButtonElement)) {
            return;
          }

          button.addEventListener('click', () => {
            if (button.disabled) {
              return;
            }

            const variantId = button.dataset.variantId;
            if (!variantId || select.value === variantId) {
              return;
            }

            select.value = variantId;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            syncButtons();
          });
        });

        select.addEventListener('change', syncButtons);
        syncButtons();
      }

      function initVariantPriceButtons(root = document) {
        root.querySelectorAll('[data-variant-price-buttons]').forEach(bindVariantPriceButtons);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initVariantPriceButtons());
      } else {
        initVariantPriceButtons();
      }

      document.addEventListener('shopify:section:load', (event) => {
        initVariantPriceButtons(event.target);
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
